/*=========================================================================================
  File Name: moduleResourceManagementMutations.js
  Description: Resource Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_RESOURCES (state, resources) {
    state.resources = resources
  },
  }
  

